import {
  renderField,
  renderValueViewCell,
} from "@lhd/components/CloneApp/untils";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { getConfigAppPartType } from "@lhd/features/Apps/utils";
import { AppSelectionList } from "@lhd/types";
import { Form } from "antd";
import { Styles } from "./style";
import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";

interface IProps {
  item: AppPartType;
  selectionDataList: AppSelectionList;
  isDisabled?: boolean;
  index?: number;
  option?: {
    namePath?: string | string[];
    isDisabled?: boolean;
    isTable?: boolean;
    onChange?: () => void;
  };
}

const CellRender = (props: IProps) => {
  const { item, selectionDataList, option, isDisabled, index } = props;

  const form = Form.useFormInstance();
  const namePath = option?.namePath || getConfigAppPartType(item).namePath;

  const renderContent = () => {
    if (item.app_part_type === APP_PART_TYPES.ATTACHMENT && index !== 0) {
      return renderField(item, selectionDataList, option);
    }

    if (isDisabled) {
      return renderValueViewCell(item, form.getFieldValue(namePath));
    }

    return renderField(item, selectionDataList, {
      ...option,
      isDisabled: false,
      onChange: option?.onChange,
    });
  };

  return <Styles>{renderContent()}</Styles>;
};

export default CellRender;
